import type {
  MeetingBasedMarketView,
  MeetingBasedRunner,
  RichContentRunnerDetails
} from '@ps/isp-web-services-types';
import React from 'react';

import { Selection, StarRating } from '@swf/sports/components';
import Silk from '@swf/sports/components/MarketTemplate/components/RaceCardList/components/Silk/Silk';

import styles from './Runner.scss';

interface Props {
  runner: MeetingBasedRunner;
  market: MeetingBasedMarketView;
}

const Runner: React.FC<Props> = ({ runner, market }) => {
  const { eventId, legTypes, marketId, marketStatus, marketTime } = market;

  if (!marketTime || !runner.ratingStars) return null;

  const { details = {} } = runner;
  const { silk } = details as RichContentRunnerDetails;

  return (
    <li className={styles.runner}>
      <div className={styles.runnerSilkContainer}>
        <div className={styles.runnerSilk}>
          <Silk silkUrl={silk} />
        </div>
      </div>
      <div className={styles.runnerDetails}>
        <span className={styles.runnerName}>{runner.runnerName}</span>
        <StarRating rating={runner.ratingStars} size="xl" />
      </div>
      <div className={styles.runnerSelection}>
        <Selection
          selectionId={runner.selectionId}
          marketStatus={marketStatus}
          odds={runner.winRunnerOdds}
          runnerStatus={runner.runnerStatus}
          marketId={marketId}
          eventId={eventId}
          legTypes={legTypes}
          startTime={marketTime}
          handicap={runner.handicap}
          isStartingPriceMarket={market.isStartingPriceMarket}
          eventTypeId={market.eventTypeId}
          competitionId={market.competitionId}
          marketType={market.marketType}
          runnerResultType={runner.resultType}
        />
      </div>
    </li>
  );
};

export default Runner;
